import moment from "moment";

import { useForm } from "react-hook-form";

import { JOBTYPE_LIST } from "@pages/shared/employeFormNew/employeForm-constants";

import { formatToNumber } from "@helpers/_functions";

const DATE_FORMAT = "YYYY-MM-DD";

export function useSalaryForm({ career, deviseList, careerList }) {
  const salaryForm = useForm({
    defaultValues: {
      title: "",
      vacancyPercentage: "",
      salaryBegin: "",
      salaryEnd: "",
      salary: "",
      jobType: {},
      isSecondaryEmployment: false,
      hoursPerWeek: "",
      hourlyRate: "",
      devise: deviseList[0],
      hourlyRateDevise: deviseList[0],
      additionalInformation: "",
      AdvantageType: [],
      career: career || null
    }
  });

  const { reset } = salaryForm;
  function resetForm() {
    reset({
      title: "",
      vacancyPercentage: "",
      salaryEnd: "",
      salaryBegin: "",
      salary: "",
      isSecondaryEmployment: false,
      jobType: {},
      hoursPerWeek: "",
      hourlyRate: "",
      devise: deviseList[0],
      hourlyRateDevise: deviseList[0],
      additionalInformation: "",
      AdvantageType: [],
      career: career || null
    });
  }

  function populateForm(salary) {
    if (!salary) {
      return null;
    }

    const hourlyRateDevise =
      deviseList.find((dev) => dev._id === salary.hourlyRateDevise) ||
      deviseList[0];

    const devise =
      deviseList.find((dev) => dev._id === salary.devise) || deviseList[0];

    const jobType = JOBTYPE_LIST.find((job) => job.value === salary.jobType);

    const salaryBegin = moment(salary.salaryBegin, DATE_FORMAT).toDate();
    const salaryEnd = salary.salaryEnd
      ? moment(salary.salaryEnd, DATE_FORMAT).toDate()
      : "";

    const _career =
      careerList?.find((career) => career._id === salary.careerId) ||
      career ||
      null;

    const advantageTypes =
      salary.AdvantageType?.length > 0
        ? salary.AdvantageType.map((adv) => ({
            _id: adv._id,
            name: adv.name,
            annualValue: adv.annualValue || "",
            annualDevise:
              deviseList.find((dev) => dev._id === adv.annualDevise) ||
              deviseList[0],
            note: adv.note || ""
          }))
        : [];

    salaryForm.reset({
      ...salary,
      salary: formatToNumber(salary.salary?.toString() || ""),
      hourlyRate: formatToNumber(salary.hourlyRate?.toString() || ""),
      devise,
      hourlyRateDevise: hourlyRateDevise,
      isSecondaryEmployment: !!salary?.isSecondaryEmployment,
      jobType: jobType,
      salaryBegin: salaryBegin,
      salaryEnd: salaryEnd,
      AdvantageType: advantageTypes,
      career: _career
    });
  }

  return { salaryForm, resetForm, populateForm };
}
